module.exports = __webpack_public_path__ + "static/img/no_logo.312abaa2.png";